import React, { useEffect, useState } from "react";
import Logo from "../../../assets/images/LOGO LAWNET WHITE.png";
import "./Header.css";
import { BsCart4 } from "react-icons/bs";
import Logout from "../../../assets/images/Logout.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useWarta } from "../../../context/WartaContext";
import api from "../../../services/baseUrl";
import Cookies from "js-cookie";

export default function Header({ handleLogout }) {
  const { cartData, setCartData } = useWarta();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const userId = JSON.parse(Cookies.get("wartaUser")).userId;
  const location = useLocation();

  useEffect(() => {
    const loadCart = async () => {
      const response = await api.post("/ewarta/cart/get", {
        userId,
      });

      if ((response.status = 200)) {
        setCartData(response.data);
      }
    };
    loadCart();
  }, [location.pathname, userId, setCartData]);
  return (
    <>
      <div className="warta-header-container">
        <div
          className="warta-header-logo"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/");
          }}
        >
          <img src={Logo} alt="" className="drawer-logo" />
        </div>
        <div className="warta-header-menu">
          <div
            className="warta-header-cart"
            onClick={() => navigate("/eWarta/cart")}
            style={{ cursor: "pointer" }}
          >
            <BsCart4 />
            <div className="warta-header-cart-counter">{cartData.length}</div>
          </div>
          <div
            className="warta-header-logout"
            onClick={() => setShowLogoutModal(true)}
            style={{ cursor: "pointer" }}
          >
            <span>Logout</span>
            <img src={Logout} alt="" style={{ height: "20px" }} />
          </div>
        </div>
      </div>
      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <p>Confirm Logout?</p>
            <div className="logout-text">
              Thank you for visiting us, <br /> and we look forward to seeing
              you again soon!
            </div>
            <div className="logout-modal-buttons">
              <button className="yes" onClick={handleLogout}>
                Yes
              </button>
              <button className="no" onClick={() => setShowLogoutModal(false)}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
